module.exports = __webpack_public_path__ + "static/media/dashboard_storage.04f00357.png";